module.exports = {"371502001":"古楼街道","371502002":"柳园街道","371502003":"新区街道","371502004":"湖西街道","371502005":"道口铺街道","371502006":"闫寺街道","371502008":"北城街道","371502009":"东城街道","371502010":"蒋官屯街道","371502011":"李海务街道","371502100":"侯营镇","371502101":"沙镇镇","371502102":"堂邑镇","371502103":"梁水镇","371502104":"斗虎屯镇","371502105":"郑家镇","371502106":"张炉集镇","371502107":"于集镇","371502108":"许营镇","371502109":"朱老庄镇","371502110":"顾官屯镇","371502115":"韩集镇","371502116":"广平镇","371502400":"香江光彩大市场服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371502.json
// module id = 1603
// module chunks = 0